// extracted by mini-css-extract-plugin
module.exports = {"submenuContainer":"_af47dd8","submenuItem":"_69f85bd","arrow":"_0a0a9e5","open":"_b0d28bf"};